import { useSuspenseQuery } from '@tanstack/react-query'

import { GetLeadRepresadoPorIdService, type TLeadRepresadoDetalhes } from '../http/get-lead-represado-por-id.service'
import { leadsRepresadosQueryKeys } from '../utils/query-keys'

export const useSuspenseLeadRepresadoPorId = (id: string) => {
  return useSuspenseQuery<TLeadRepresadoDetalhes>({
    queryKey: leadsRepresadosQueryKeys.leadRepresadoPorId(id),
    queryFn: async () => new GetLeadRepresadoPorIdService().execute({ id }).then((res) => res.data),
  })
}
